module.exports = __webpack_public_path__ + "img/samsung860evo.dedc3305.jpeg";